export default __webpack_public_path__ + "static/media/002.84eecb0d.jpg";